export enum EHeaderMediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}
